export default "__VITE_ASSET__BmcfxM8G__"